"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CLUSTER_CIRCLE_RADIUS () {
        return CLUSTER_CIRCLE_RADIUS;
    },
    get CLUSTER_COUNT_DISPLAY () {
        return CLUSTER_COUNT_DISPLAY;
    },
    get FLOODZONES () {
        return FLOODZONES;
    },
    get generateFloodzoneLabelLayer () {
        return generateFloodzoneLabelLayer;
    },
    get generateFloodzoneLabelLayerPaint () {
        return generateFloodzoneLabelLayerPaint;
    },
    get generateFloodzoneLayerPaint () {
        return generateFloodzoneLayerPaint;
    },
    get generateFloodzoneLayerPatternPaint () {
        return generateFloodzoneLayerPatternPaint;
    },
    get generateFloodzoneOutlineLayerPaint () {
        return generateFloodzoneOutlineLayerPaint;
    },
    get getScaledImageName () {
        return getScaledImageName;
    }
});
const _lodash = require("lodash");
const _constants = require("../../constants");
const createNumberedZones = (prefix)=>{
    return Array.from({
        length: 30
    }, (_, number)=>`${prefix}${number + 1}`);
};
const FLOODZONES = [
    {
        color: "rgba(0, 0, 0, 0)",
        zones: [
            "X"
        ],
        transparent: true,
        pattern: _constants.MAP_LAYER_PATTERNS.CROSS_HATCH
    },
    {
        color: "#f8cb44",
        zones: [
            "X500",
            "B"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.CROSS
    },
    {
        color: "#e67f99",
        zones: createNumberedZones("A").concat("AE"),
        label: "AE, A1-A30",
        pattern: _constants.MAP_LAYER_PATTERNS.SQUARE
    },
    {
        color: "#e67fd1",
        zones: [
            "AO",
            "AH",
            "AR/AO"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.TRIANGLE
    },
    {
        color: "#e6a07f",
        zones: [
            "A"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.STAR
    },
    {
        color: "#c70000",
        zones: createNumberedZones("V").concat("VE"),
        label: "VE, V1-V30",
        pattern: _constants.MAP_LAYER_PATTERNS.CIRCLE
    },
    {
        color: "#eb4069",
        zones: [
            "V"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.GRID
    },
    {
        color: "#0190bc",
        zones: [
            "D"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.HORIZONTAL
    },
    {
        color: "#ea7204",
        zones: [
            "AR"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.VERTICAL
    }
];
const generateFloodzoneLayerPaint = ()=>{
    const fillColors = (0, _lodash.flatMap)(FLOODZONES, ({ zones, color })=>{
        return [
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                zones,
                true,
                false
            ],
            color
        ];
    });
    return {
        "fill-color": [
            "case",
            ...fillColors,
            "rgba(0, 0, 0, 0)"
        ],
        "fill-outline-color": "rgba(255, 255, 255, 0)",
        "fill-opacity": 0.35
    };
};
const generateFloodzoneLayerPatternPaint = ()=>{
    const buildFloodZoneCase = (scale)=>{
        const fillPatterns = (0, _lodash.flatMap)(FLOODZONES, ({ zones, pattern })=>{
            const patternName = getScaledImageName(pattern, scale);
            return [
                [
                    "match",
                    [
                        "get",
                        "flood_zone"
                    ],
                    zones,
                    true,
                    false
                ],
                patternName
            ];
        });
        return [
            "case",
            ...fillPatterns,
            "rgba(0, 0, 0, 0)"
        ];
    };
    const baseCase = buildFloodZoneCase(1);
    const case2x = buildFloodZoneCase(2);
    const case4x = buildFloodZoneCase(4);
    const paintExpression = [
        "step",
        [
            "zoom"
        ],
        baseCase,
        20,
        case2x,
        22,
        case4x
    ];
    return {
        "fill-pattern": paintExpression,
        "fill-opacity": 1
    };
};
const getScaledImageName = (name, scale)=>{
    switch(scale){
        case 1:
            return name;
        case 2:
            return `${name}-2x`;
        case 4:
            return `${name}-4x`;
        default:
            return name;
    }
};
const generateFloodzoneOutlineLayerPaint = ()=>{
    return {
        "line-color": "rgb(0,0,0)",
        "line-opacity": 0.5,
        "line-width": 0.8
    };
};
const generateFloodzoneLabelLayerPaint = ()=>{
    return {
        "text-color": "#ffffff",
        "text-halo-color": "rgba(5, 5, 5, 0.82)",
        "text-opacity": [
            "step",
            [
                "zoom"
            ],
            0,
            12,
            1
        ],
        "text-halo-width": 1
    };
};
const generateFloodzoneLabelLayer = ({ zoneCopy = "Zone", elevationAbbr = "EL", depthAbbr = "depth", translations })=>{
    const keyMatcher = (key, translations)=>{
        const englishKey = key.replace("_key", "");
        return [
            "downcase",
            [
                "coalesce",
                [
                    "match",
                    [
                        "get",
                        key
                    ],
                    ...Object.entries(translations).flat(),
                    [
                        "get",
                        englishKey
                    ]
                ]
            ]
        ];
    };
    const getDescription = translations ? keyMatcher("description_key", translations) : [
        "downcase",
        [
            "coalesce",
            [
                "get",
                "description"
            ],
            ""
        ]
    ];
    const getLengthUnits = translations ? keyMatcher("length_units_key", translations) : [
        "downcase",
        [
            "get",
            "length_units"
        ]
    ];
    return {
        "text-field": [
            "case",
            [
                "has",
                "static_bfe"
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "get",
                    "flood_zone"
                ],
                `\n(${elevationAbbr} `,
                [
                    "to-string",
                    [
                        "get",
                        "static_bfe"
                    ]
                ],
                " ",
                getLengthUnits,
                ")"
            ],
            [
                "has",
                "depth"
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "get",
                    "flood_zone"
                ],
                `\n(${depthAbbr} `,
                [
                    "to-string",
                    [
                        "get",
                        "depth"
                    ]
                ],
                " ",
                getLengthUnits,
                ")"
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "X",
                    "X500"
                ],
                true,
                false
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "to-string",
                    [
                        "get",
                        "flood_zone"
                    ]
                ],
                "\n",
                getDescription
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "AREA NOT INCLUDED"
                ],
                true,
                false
            ],
            [
                "to-string",
                [
                    "get",
                    "flood_zone"
                ]
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "OPEN WATER"
                ],
                true,
                false
            ],
            "",
            [
                "concat",
                `${zoneCopy} `,
                [
                    "to-string",
                    [
                        "get",
                        "flood_zone"
                    ]
                ]
            ]
        ],
        "text-padding": 10,
        "text-max-width": 18.5,
        "text-size": [
            "interpolate",
            [
                "exponential",
                1
            ],
            [
                "zoom"
            ],
            3,
            10,
            10,
            12
        ],
        "text-font": [
            "DIN Offc Pro Bold",
            "Arial Unicode MS Regular"
        ],
        "symbol-avoid-edges": false
    };
};
const CLUSTER_CIRCLE_RADIUS = [
    "step",
    [
        "get",
        "count"
    ],
    24,
    100,
    28,
    1000,
    32
];
const CLUSTER_COUNT_DISPLAY = [
    "case",
    [
        ">=",
        [
            "get",
            "count"
        ],
        100000000
    ],
    [
        "concat",
        [
            "round",
            [
                "/",
                [
                    "get",
                    "count"
                ],
                1000000
            ]
        ],
        "M"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        999500
    ],
    [
        "concat",
        [
            "/",
            [
                "round",
                [
                    "/",
                    [
                        "get",
                        "count"
                    ],
                    100000
                ]
            ],
            10
        ],
        "M"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        99950
    ],
    [
        "concat",
        [
            "round",
            [
                "/",
                [
                    "get",
                    "count"
                ],
                1000
            ]
        ],
        "K"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        1000
    ],
    [
        "concat",
        [
            "/",
            [
                "round",
                [
                    "/",
                    [
                        "get",
                        "count"
                    ],
                    100
                ]
            ],
            10
        ],
        "K"
    ],
    [
        "get",
        "count"
    ]
];

//# sourceMappingURL=data:application/json;base64,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